"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CLUSTER_CIRCLE_RADIUS () {
        return CLUSTER_CIRCLE_RADIUS;
    },
    get CLUSTER_COUNT_DISPLAY () {
        return CLUSTER_COUNT_DISPLAY;
    },
    get FLOODZONES () {
        return FLOODZONES;
    },
    get generateFloodzoneLabelLayer () {
        return generateFloodzoneLabelLayer;
    },
    get generateFloodzoneLabelLayerPaint () {
        return generateFloodzoneLabelLayerPaint;
    },
    get generateFloodzoneLayerPaint () {
        return generateFloodzoneLayerPaint;
    },
    get generateFloodzoneLayerPatternPaint () {
        return generateFloodzoneLayerPatternPaint;
    },
    get generateFloodzoneOutlineLayerPaint () {
        return generateFloodzoneOutlineLayerPaint;
    },
    get getScaledImageName () {
        return getScaledImageName;
    }
});
const _lodash = require("lodash");
const _constants = require("../../constants");
const createNumberedZones = (prefix)=>{
    return Array.from({
        length: 30
    }, (_, number)=>`${prefix}${number + 1}`);
};
const FLOODZONES = [
    {
        color: "rgba(0, 0, 0, 0)",
        zones: [
            "X"
        ],
        transparent: true,
        pattern: _constants.MAP_LAYER_PATTERNS.CROSS_HATCH
    },
    {
        color: "#f8cb44",
        zones: [
            "X500",
            "B"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.CROSS
    },
    {
        color: "#e67f99",
        zones: createNumberedZones("A").concat("AE"),
        label: "AE, A1-A30",
        pattern: _constants.MAP_LAYER_PATTERNS.SQUARE
    },
    {
        color: "#e67fd1",
        zones: [
            "AO",
            "AH",
            "AR/AO"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.TRIANGLE
    },
    {
        color: "#e6a07f",
        zones: [
            "A"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.STAR
    },
    {
        color: "#c70000",
        zones: createNumberedZones("V").concat("VE"),
        label: "VE, V1-V30",
        pattern: _constants.MAP_LAYER_PATTERNS.CIRCLE
    },
    {
        color: "#eb4069",
        zones: [
            "V"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.GRID
    },
    {
        color: "#0190bc",
        zones: [
            "D"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.HORIZONTAL
    },
    {
        color: "#ea7204",
        zones: [
            "AR"
        ],
        pattern: _constants.MAP_LAYER_PATTERNS.VERTICAL
    }
];
const generateFloodzoneLayerPaint = ()=>{
    const fillColors = (0, _lodash.flatMap)(FLOODZONES, ({ zones, color })=>{
        return [
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                zones,
                true,
                false
            ],
            color
        ];
    });
    return {
        "fill-color": [
            "case",
            ...fillColors,
            "rgba(0, 0, 0, 0)"
        ],
        "fill-outline-color": "rgba(255, 255, 255, 0)",
        "fill-opacity": 0.35
    };
};
const generateFloodzoneLayerPatternPaint = ()=>{
    const buildFloodZoneCase = (scale)=>{
        const fillPatterns = (0, _lodash.flatMap)(FLOODZONES, ({ zones, pattern })=>{
            const patternName = getScaledImageName(pattern, scale);
            return [
                [
                    "match",
                    [
                        "get",
                        "flood_zone"
                    ],
                    zones,
                    true,
                    false
                ],
                patternName
            ];
        });
        return [
            "case",
            ...fillPatterns,
            "rgba(0, 0, 0, 0)"
        ];
    };
    const baseCase = buildFloodZoneCase(1);
    const case2x = buildFloodZoneCase(2);
    const case4x = buildFloodZoneCase(4);
    const paintExpression = [
        "step",
        [
            "zoom"
        ],
        baseCase,
        20,
        case2x,
        22,
        case4x
    ];
    return {
        "fill-pattern": paintExpression,
        "fill-opacity": 1
    };
};
const getScaledImageName = (name, scale)=>{
    switch(scale){
        case 1:
            return name;
        case 2:
            return `${name}-2x`;
        case 4:
            return `${name}-4x`;
        default:
            return name;
    }
};
const generateFloodzoneOutlineLayerPaint = ()=>{
    return {
        "line-color": "rgb(0,0,0)",
        "line-opacity": 0.5,
        "line-width": 0.8
    };
};
const generateFloodzoneLabelLayerPaint = ()=>{
    return {
        "text-color": "#ffffff",
        "text-halo-color": "rgba(5, 5, 5, 0.82)",
        "text-opacity": [
            "step",
            [
                "zoom"
            ],
            0,
            12,
            1
        ],
        "text-halo-width": 1
    };
};
const generateFloodzoneLabelLayer = ({ zoneCopy = "Zone", elevationAbbr = "EL", depthAbbr = "depth", translations })=>{
    const keyMatcher = (key, translations)=>{
        const englishKey = key.replace("_key", "");
        return [
            "downcase",
            [
                "coalesce",
                [
                    "match",
                    [
                        "get",
                        key
                    ],
                    ...Object.entries(translations).flat(),
                    [
                        "get",
                        englishKey
                    ]
                ]
            ]
        ];
    };
    const getDescription = translations ? keyMatcher("description_key", translations) : [
        "downcase",
        [
            "coalesce",
            [
                "get",
                "description"
            ],
            ""
        ]
    ];
    const getLengthUnits = translations ? keyMatcher("length_units_key", translations) : [
        "downcase",
        [
            "get",
            "length_units"
        ]
    ];
    return {
        "text-field": [
            "case",
            [
                "has",
                "static_bfe"
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "get",
                    "flood_zone"
                ],
                `\n(${elevationAbbr} `,
                [
                    "to-string",
                    [
                        "get",
                        "static_bfe"
                    ]
                ],
                " ",
                getLengthUnits,
                ")"
            ],
            [
                "has",
                "depth"
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "get",
                    "flood_zone"
                ],
                `\n(${depthAbbr} `,
                [
                    "to-string",
                    [
                        "get",
                        "depth"
                    ]
                ],
                " ",
                getLengthUnits,
                ")"
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "X",
                    "X500"
                ],
                true,
                false
            ],
            [
                "concat",
                `${zoneCopy} `,
                [
                    "to-string",
                    [
                        "get",
                        "flood_zone"
                    ]
                ],
                "\n",
                getDescription
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "AREA NOT INCLUDED"
                ],
                true,
                false
            ],
            [
                "to-string",
                [
                    "get",
                    "flood_zone"
                ]
            ],
            [
                "match",
                [
                    "get",
                    "flood_zone"
                ],
                [
                    "OPEN WATER"
                ],
                true,
                false
            ],
            "",
            [
                "concat",
                `${zoneCopy} `,
                [
                    "to-string",
                    [
                        "get",
                        "flood_zone"
                    ]
                ]
            ]
        ],
        "text-padding": 10,
        "text-max-width": 18.5,
        "text-size": [
            "interpolate",
            [
                "exponential",
                1
            ],
            [
                "zoom"
            ],
            3,
            10,
            10,
            12
        ],
        "text-font": [
            "DIN Offc Pro Bold",
            "Arial Unicode MS Regular"
        ],
        "symbol-avoid-edges": false
    };
};
const CLUSTER_CIRCLE_RADIUS = [
    "step",
    [
        "get",
        "count"
    ],
    24,
    100,
    28,
    1000,
    32
];
const CLUSTER_COUNT_DISPLAY = [
    "case",
    [
        ">=",
        [
            "get",
            "count"
        ],
        100000000
    ],
    [
        "concat",
        [
            "round",
            [
                "/",
                [
                    "get",
                    "count"
                ],
                1000000
            ]
        ],
        "M"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        999500
    ],
    [
        "concat",
        [
            "/",
            [
                "round",
                [
                    "/",
                    [
                        "get",
                        "count"
                    ],
                    100000
                ]
            ],
            10
        ],
        "M"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        99950
    ],
    [
        "concat",
        [
            "round",
            [
                "/",
                [
                    "get",
                    "count"
                ],
                1000
            ]
        ],
        "K"
    ],
    [
        ">=",
        [
            "get",
            "count"
        ],
        1000
    ],
    [
        "concat",
        [
            "/",
            [
                "round",
                [
                    "/",
                    [
                        "get",
                        "count"
                    ],
                    100
                ]
            ],
            10
        ],
        "K"
    ],
    [
        "get",
        "count"
    ]
];

//# sourceMappingURL=data:application/json;base64,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